import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/api";

export function useOrderDetail(invoiceId: string) {
  return useQuery({
    queryKey: ["order-detail", invoiceId],
    queryFn: () => apiCall<any>(`orders/${encodeURIComponent(invoiceId)}`),
  });
}
